import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { APIService } from '@services/api/common-services';
import { APICONFIG } from '@config/api.config';
import { IContractorDetailsResponse } from '.';

interface ContractorPhone {
	phone: string;
}

interface IContractorDetailsQueryResponse {
	data?: IContractorDetailsResponse;
	mutate: UseMutateFunction<IContractorDetailsResponse, Error, ContractorPhone, unknown>;
	error: Error | null;
	isError: boolean;
	isPending: boolean;
}

export const useContractorDetailsQuery = (): IContractorDetailsQueryResponse => {
	const fetchContractorDetails = async (params: ContractorPhone): Promise<IContractorDetailsResponse> => {
		const url = `${APICONFIG.LMS_CONTRACTOR}?phone=${params.phone}`;
		const response = await APIService.getData<{ message: string; data: IContractorDetailsResponse }>(url);
		return response.data ? response.data : response;
	};

	const { mutate, error, isError, isPending, data } = useMutation({
		mutationFn: fetchContractorDetails,
	});

	return {
		data,
		mutate,
		error,
		isError,
		isPending,
	};
};
